import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "left-nav-wrap"
};
const _hoisted_2 = {
  class: "left-sub-menu-wrap"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "sub-menu-item"
};
const _hoisted_5 = {
  key: 0,
  class: "ml-5"
};
import { Menu as IconMenu, House, Avatar, UploadFilled, ArrowLeft, CaretRight, QuestionFilled } from '@element-plus/icons-vue';
import { computed, ref, watch, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
import { useManualTestStore } from '@/store/manualTest';
export default /*@__PURE__*/_defineComponent({
  __name: 'MctLeftNav',
  setup(__props) {
    const store = useUserDefaultSettingStore();
    const {
      preferences,
      privilege
    } = storeToRefs(store);
    const {
      setLocalStorage,
      getLocalStorage
    } = store;
    const manualTestStore = useManualTestStore();
    const {
      isShowManualTestDialog
    } = storeToRefs(manualTestStore);
    const sidebarMenuRef = ref();
    const leftMenu = [{
      name: 'Home',
      value: 'Home',
      icon: House,
      privilege: 0,
      items: [{
        name: 'Customized View',
        value: '/customized-view',
        privilege: 0
      }, {
        name: 'Cluster View',
        value: '/cluster-view',
        privilege: 0
      },
      // {
      //   name: 'Service View',
      //   value: '/service-view',
      //   privilege: 100
      // },
      {
        name: 'MCT Service View',
        value: '/mct-service-view',
        privilege: 0
      }]
    }, {
      name: 'Management',
      value: 'Management',
      icon: IconMenu,
      privilege: 0,
      items: [{
        name: 'Infrastructure',
        value: '/infrastructure',
        privilege: 100
      }, {
        name: 'Alert Rules',
        value: '/alert-rules',
        privilege: 0
      }, {
        name: 'Data Center',
        value: '/data-center',
        privilege: 100
      }, {
        name: 'URL Template',
        value: '/url-template',
        privilege: 100
      }, {
        name: 'SvrType Settings',
        value: '/svrtype-setting',
        privilege: 255
      }, {
        name: 'Customized Settings',
        value: '/customized-settings',
        privilege: 100
      }, {
        name: 'MCT Service Settings',
        value: '/mct-service-settings',
        privilege: 100
      }, {
        name: 'Import/Export Cluster',
        value: '/import-export-cluster',
        privilege: 100
      }
      // {
      //   name: 'Appium Test Case',
      //   value: '/appium-test-case',
      //   privilege: 0
      // }
      ]
    }, {
      name: 'Agents',
      value: 'Agents',
      icon: UploadFilled,
      privilege: 255,
      items: [{
        name: 'Cloud Agent Dispatch',
        value: '/cloud-agent-dispatch',
        privilege: 255
      }, {
        name: 'Cloud Agent Manage',
        value: '/cloud-agent-manage',
        privilege: 255
      }]
    }, {
      name: 'Admin',
      value: 'Admin',
      icon: Avatar,
      privilege: 100,
      items: [{
        name: 'Activity Log',
        value: '/activity-log',
        privilege: 255
      }, {
        name: 'User List',
        value: '/user-list',
        privilege: 100
      }, {
        name: 'Plugin List',
        value: '/plugin-list',
        privilege: 255
      }, {
        name: 'Failover MCT',
        value: '/failover-mct',
        privilege: 255
      }]
    }];
    const opends = ref([]);
    const route = useRoute();
    const router = useRouter();
    const onRoutes = computed(() => {
      return route.path;
    });
    const isMenuCollapse = ref(preferences.value.collapseLeftMenu || getLocalStorage('COLLAPSE_LEFT_MENU') || false);
    const reverseCollapseIcon = computed(() => isMenuCollapse.value ? 'reverse-collapse-icon' : '');
    const leftNavMenuClass = computed(() => isMenuCollapse.value ? '' : 'expanded-menu');
    const collapseOrExpandMenu = () => {
      isMenuCollapse.value = !isMenuCollapse.value;
      setLocalStorage('COLLAPSE_LEFT_MENU', isMenuCollapse.value);
    };
    const checkNoMenuPath = () => {
      const list = ['/service-view', '/appium-test-case', '/appium-test-account', '/cluster-status', '/detail-status'];
      return list.some(v => router.currentRoute.value.fullPath.includes(v));
    };
    const isActive = menuItem => route.matched.some(v => v.path === menuItem.value || v.meta?.parentSideItem === menuItem.value);
    const getActiveOpens = () => {
      let index = -1;
      if (route.matched && route.matched.length > 1) {
        index = leftMenu?.findIndex(v => v.items.some(i => i.name === route.matched[1].name));
      }
      return index === -1 ? checkNoMenuPath() ? [] : ['Home'] : [leftMenu[index]['value']];
    };
    watch(() => router.currentRoute.value.fullPath, () => {
      if (sidebarMenuRef.value && !preferences.value.collapseLeftMenu && !checkNoMenuPath()) {
        sidebarMenuRef.value.open(getActiveOpens());
      }
    });
    onBeforeMount(() => {
      // @ts-ignore
      opends.value = getActiveOpens();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("nav", _hoisted_1, [_createVNode(_component_el_menu, {
        ref_key: "sidebarMenuRef",
        ref: sidebarMenuRef,
        "active-text-color": "#2f76e6",
        class: _normalizeClass(leftNavMenuClass.value),
        "default-active": onRoutes.value,
        "default-openeds": opends.value,
        collapse: isMenuCollapse.value,
        router: ""
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(leftMenu, subMenu => {
          return _withDirectives(_createVNode(_component_el_sub_menu, {
            key: subMenu.value,
            index: subMenu.value
          }, {
            title: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(subMenu.icon)))]),
              _: 2
            }, 1024), _createElementVNode("span", null, _toDisplayString(subMenu.name), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subMenu.items, item => {
              return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                key: item.value,
                index: item.value,
                class: _normalizeClass({
                  isActive: isActive(item)
                })
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["index", "class"])), [[_vShow, _unref(privilege) >= item.privilege]]);
            }), 128))]),
            _: 2
          }, 1032, ["index"]), [[_vShow, _unref(privilege) >= subMenu.privilege]]);
        }), 64))]),
        _: 1
      }, 8, ["class", "default-active", "default-openeds", "collapse"])]), _createElementVNode("div", {
        class: _normalizeClass(["collapse-expand-menu-btn pointer", reverseCollapseIcon.value]),
        onClick: _withModifiers(collapseOrExpandMenu, ["stop"])
      }, [_createVNode(_component_el_icon, {
        size: 16
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
        _: 1
      })], 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "sub-menu-item manual-test-list-wrap pointer",
        onClick: _cache[0] || (_cache[0] = $event => isShowManualTestDialog.value = true)
      }, [_createVNode(_component_el_icon, {
        size: 15,
        class: "manual-test-list"
      }, {
        default: _withCtx(() => [_createVNode(_unref(CaretRight))]),
        _: 1
      }), !isMenuCollapse.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Manual Test List")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_link, {
        href: "/docs/home.html",
        target: "_blank",
        "aria-label": "redirect to MCT docs",
        underline: false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 19
        }, {
          default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
          _: 1
        }), !isMenuCollapse.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, "MCT Guide")) : _createCommentVNode("", true)]),
        _: 1
      })])])], 64);
    };
  }
});